import { render } from "./email-notifications-confirm-modal.vue?vue&type=template&id=a45ef5e9"
import script from "./email-notifications-confirm-modal.vue?vue&type=script&lang=js"
export * from "./email-notifications-confirm-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__